module.exports = __webpack_public_path__ + "img/e_3_26_r.d11de070.png";